// extracted by mini-css-extract-plugin
module.exports = {"container":"order-id__container___2FZq1","idLabel":"order-id__idLabel___2ZUD3","copyBtn":"order-id__copyBtn___1386b","copiedIndicator":"order-id__copiedIndicator___26mRf"};